import { PageErrorState } from '@components/core-ui/PageErrorState';
import { Header } from '@components/Header';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { usePageContext } from '../../providers/PageProvider';

import { MainContent } from './components/MainContent';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { isLoading, jobDataErrors, retryJobData } = usePageContext();

  return (
    <>
      <Header title="Job Details" />
      <LinearProgressLoader active={isLoading} />
      <Wrapper>
        {jobDataErrors.map((domain) => (
          <PageErrorState
            key={domain}
            message={`Couldn't load job ${domain}`}
            actionLabel="Retry"
            onAction={() => retryJobData(domain)}
          />
        ))}
        <MainContent />
      </Wrapper>
    </>
  );
};
